<template>
  <div class="group-meals-stats">
    <v-progress-linear v-if="loading" indeterminate color="primary" height="2" />

    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab v-for="item in tabDefs" :key="item.key">
        <v-icon style="margin-right: 7px">{{ item.icon }}</v-icon>
        {{ item.label }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" :touchless="true">
      <v-tab-item>
        <div class="px-2 mt-2">
          <group-meals-meals-chart :orders="orders" />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="px-2 mt-2">
          <group-meals-shifts-chart :orders="orders" />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="px-2 mt-2">
          <group-meals-days-chart :orders="orders" />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="px-2 mt-2">
          <group-meals-days-meals-chart :orders="orders" />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="px-2 mt-2">
          <group-meals-companies-chart :orders="orders" />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import reportService from "@/services/report";
import GroupMealsMealsChart from "@/components/statistics/group-meals/GroupMealsMealsChart.vue";
import GroupMealsShiftsChart from "@/components/statistics/group-meals/GroupMealsShiftsChart.vue";
import GroupMealsDaysChart from "@/components/statistics/group-meals/GroupMealsDaysChart.vue";
import GroupMealsCompaniesChart from "@/components/statistics/group-meals/GroupMealsCompaniesChart.vue";
import GroupMealsDaysMealsChart from "@/components/statistics/group-meals/GroupMealsDaysMealsChart.vue";

export default {
  name: "RestaurantGroupMealsStats",
  components: {
    GroupMealsMealsChart,
    GroupMealsShiftsChart,
    GroupMealsDaysChart,
    GroupMealsCompaniesChart,
    GroupMealsDaysMealsChart,
  },
  props: {
    date: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: false,
      orders: [],
      tab: 0,
    };
  },
  computed: {
    tabDefs() {
      return [
        { key: "meals", icon: "mdi-food-drumstick", label: this.$t("meal_in_meals") },
        {
          key: "shifts",
          icon: "mdi-clock-time-four-outline",
          label: this.$t("orders_by_shift"),
        },
        { key: "days", icon: "mdi-calendar-range", label: this.$t("daily") },
        { key: "days_meals", icon: "mdi-food-drumstick-outline", label: this.$t("meal_in_meals") + " / " + this.$t("daily") },
        { key: "companies", icon: "mdi-office-building", label: this.$t("companies") },
      ];
    },
  },
  methods: {
    async fetchData() {
      const restaurantId = this.$store.state.restaurant?.id;
      if (!restaurantId || !this.date?.length) return;
      this.loading = true;
      try {
        const from = this.date[0];
        const to = this.date[1] || this.date[0];
        const ordersRes = await reportService.getFoodOrdersOrderedV2(restaurantId, { date: from, date2: to, orderby: "date" });
        this.orders = Array.isArray(ordersRes.data) ? ordersRes.data : [];
      } catch {
        this.orders = [];
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    date: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style scoped>
.group-meals-stats ::v-deep .v-tabs-items,
.group-meals-stats ::v-deep .v-window__container,
.group-meals-stats ::v-deep .v-window-item {
  overflow: visible !important;
}
</style>
